import { useIntersectionObserver } from "@react-hookz/web";
import { useEffect, useRef, useState } from "react";
import type { FunctionComponent } from "react";

import { MynewsText } from "scmp-app/components/my-news/mynews-text";

import Computer from "./computer.png";
import Phones from "./phones.png";
import {
  BigCircle,
  Container,
  Description,
  ImageComputer,
  ImageContainer,
  ImagePhones,
  SmallCircle,
  TextWrapper,
  Title,
} from "./styles";

export const WhatIsMynews: FunctionComponent = () => {
  const [isShowAnimation, setIsShowAnimation] = useState(false);
  const containerReference = useRef<HTMLDivElement>(null);
  const observer = useIntersectionObserver(containerReference, { threshold: [0.5] });

  useEffect(() => {
    if (isShowAnimation) return;
    if (observer?.isIntersecting) setIsShowAnimation(true);
  }, [isShowAnimation, observer?.isIntersecting]);

  return (
    <Container ref={containerReference}>
      <TextWrapper>
        <Title>
          What is <MynewsText />?
        </Title>
        <Description>
          We curate news that matters to you with our <br />
          <span>Daily 5 must-read articles</span> plus a comprehensive list of stories from your
          favourite topics.
        </Description>
      </TextWrapper>
      <ImageContainer $isActive={isShowAnimation}>
        <BigCircle $isActive={isShowAnimation} />
        <SmallCircle $isActive={isShowAnimation} />
        <ImageComputer $isActive={isShowAnimation} alt="myNews" src={Computer.src} />
        <ImagePhones $isActive={isShowAnimation} alt="myNews" src={Phones.src} />
      </ImageContainer>
    </Container>
  );
};

WhatIsMynews.displayName = "WhatIsMynews";
